<template>
  <div class="card card-hover border-2 mb-4 shadow-lg" style="width: 100%;">
    <div class="card-body">
      <div class="card-title mx-0 py-2">
        <div class="row mb-2">
          <div class="col-6 ps-0" align="left">
            <div v-if="network.public" :title="this.$t('NetworkCard.private-access')" class="badge rounded-pill text-dark fw-bold ps-0">
              <i class="fas fa-lock-open"></i>
              {{ $t('NetworkCard.public-access') }}
            </div>
            <div v-else :title="this.$t('NetworkCard.private-access')" class="badge rounded-pill text-dark fw-bold ps-0">
              <i class="fas fa-lock"></i>
              {{ $t('NetworkCard.private-access') }}
            </div>
          </div>
          <div class="col-6" align="right">
            <Fav v-if="network.is_mine" :loading="busy" :value="network.is_liked" @input="toggleFavStatus" />
            <div v-if="network_notifications.length > 0 && $auth.auth">
              <i class="fas fa-bookmark" style="position: absolute; margin-left: -47px; font-size: 28px; margin-top: -8px; color: #005F9A;"></i>
              <i class="fas fa-bell text-white" style="font-size: 13px; position: absolute; margin-left: -42px; margin-top: -4px; transform: rotate(25deg);"></i>
              <span v-if="network_notifications.length <= 5" class="rounded-pill notification" style="padding: 2px 6px;">
                {{ network_notifications.length }}
              </span>
              <span v-if="network_notifications.length > 5" class="rounded-pill notification">
                5+
              </span>
            </div>
          </div>
        </div>
        <router-link :to="{ name: 'network-home', params: { slug: network.slug } }" class="fs-5" style="text-decoration: none;">
          {{ network.name }}
        </router-link>
      </div>
      <div v-if="network.members_count" :title="$t('NetworkCard.members')" class="float-end">
        <i class="fas fa-users"></i>
        {{ network.members_count }}
      </div>

      <div v-if="network.purpose" class="card-text pointer">
        <router-link :to="{ name: 'network-home', params: { slug: network.slug } }" style="all: unset;">
          {{ network.purpose.slice(0, 120) }}
          <span v-if="network.purpose.length > 120" class="text-primary">
            {{ $t('CardSmall.read-more') }}
          </span>
        </router-link>
      </div>
    </div>
    <div class="card-footer border-0 text-center pb-2">
      <p v-if="network.is_in_moderation_queue && showJoin && canJoin">
        <small v-if="network.is_in_moderation_queue && network.join_status == 'REJECTED'" class="text text-muted">
          <strong>
            <i class="fa fa-ban"></i>
            {{ $t('NetworkCard.your-request-has-been-rejected') }}
          </strong>
        </small>
        <small v-else class="text text-primary">
          <strong>
            <i class="fas fa-exclamation-circle"></i>
            {{ $t('your-request-to-join-this-network-is-being-reviewed-we-will-get-back-to-you-soon') }}
          </strong>
        </small>
      </p>
      <button
        v-if="showJoin && canJoin"
        id="join"
        variant="primary"
        data-test="join"
        :class="[network.is_in_moderation_queue && network.join_status == 'REJECTED' ? 'd-none' : '']"
        :disabled="network.is_in_moderation_queue"
        class="btn btn-primary btn-sm animate-fill btn-block text-uppercase rounded-3"
        @click="join"
      >
        <span v-if="network.is_in_moderation_queue && network.join_status != 'REJECTED' ||
        network.is_in_industry_moderation_queue && network.industry_join_status != 'REJECTED'">
          {{ $t('ModerationTab.pending') }}
        </span>
        <span v-if="!network.is_in_moderation_queue && !network.is_in_industry_moderation_queue">
          <span v-if="network.moderation">{{ $t('network.request-to-join') }}</span>
          <span v-if="!network.moderation">{{ $t('network.join') }}</span>
        </span>
      </button>
    </div>
  </div>
</template>
<script>
import { JoinNetworkMixin } from '@/mixins/Network/JoinNetworkMixin.js';
import Fav from '@/components/Fav.vue';
import { mapState } from 'vuex';

export default {
  components: {
    Fav,
  },
  mixins: [JoinNetworkMixin],
  props: {
    network: {
      type: Object,
      default: null,
    },
    showJoin: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      busy: false,
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      notifications: state => state.notifications.notifications,
    }),
    network_notifications() {
      let filteredNotifications = [];
      this.notifications.forEach(element => {
        if (element.network && element.network == this.network.slug) {
          filteredNotifications.push(element);
        }
      });
      return filteredNotifications;
    },
    canJoin() {
      return !this.network.is_mine && this.network.public;
    },
  },
  methods: {
    toggleFavStatus() {
      this.busy = true;
      const wasLiked = this.network.is_liked;
      this.$store.dispatch('network/toggleFavStatus', this.network.slug)
        .then(() => {
          this.busy = false;
          // track the opposite of the previous state since we toggled
          const eventAction = wasLiked ? 'unlike' : 'like';
          // umami tracking
          if (window.umami && typeof window.umami.track === 'function') {
            window.umami.track(`${eventAction}-network-${this.network.id}`);
          }
        });
    },
    join() {
      this.busy = true;
      this.joinNetwork(this.network);
    },
  },
};
</script>
<style scoped>
.card-body {
  padding: 0px 20px 5px 20px !important;
}
.badge {
  color: gray !important;
  font-size: 13px;
}
.network-title {
  font-size: 20px;
}
.notification {
  position: absolute;
  font-size: 9px;
  color: white !important;
  padding: 4px;
  margin-left: -56px;
  background: rgb(179, 179, 179);
  margin-top: 7px;
}
</style>
